/**
 * Utilities
 *
 */

import scrollAnimation from './scrollAnimation.js';
import getClosest from './getClosest.js';
import getTransitionEvent from './getTransitionEvent.js';
import buildSelectorAttribute from './buildSelectorAttribute.js';
import getCoordinates from './getCoordinates';

let utilities = {
  scrollAnimation: scrollAnimation,
  getClosest: getClosest,
  getTransitionEvent: getTransitionEvent,
  buildSelectorAttribute: buildSelectorAttribute,
  getCoordinates: getCoordinates
};

export default utilities;
